import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { ADD_NEW_USER_FAILED, ADD_NEW_USER_SUCCESS, CHANGE_ROLE_ACCESS_SCRREN_FAILED, 
    CHANGE_ROLE_ACCESS_SCRREN_SUCCESS, CHANGE_USER_ROLE_FAILED, CHANGE_USER_ROLE_SUCCESS, DELETE_USER_FAILED, 
    DELETE_USER_SUCCESS, EDIT_CRADICIALS_FAILED, EDIT_CRADICIALS_SUCCESS, EDIT_USER_FAILED, EDIT_USER_SUCCESS, 
    GET_CRADICIALS_FAILED, GET_CRADICIALS_SUCCESS, GET_DOMAINWHITELIST_CSV_DATA_FAILED, GET_DOMAINWHITELIST_CSV_DATA_SUCCESS, 
    GET_LOGGER_DATA_FAILED, GET_LOGGER_DATA_SUCCESS, GET_USERS_LIST_FAILED, GET_USERS_LIST_REQUEST, GET_USERS_LIST_SUCCESS, 
    GET_USER_PERMISSION_DATA_FAILED, GET_USER_PERMISSION_DATA_SUCCESS, UPLOAD_APP_WHITELIST_FAILED, UPLOAD_APP_WHITELIST_SUCCESS, 
    UPLOAD_DOMAIN_WHITELIST_FAILED, UPLOAD_DOMAIN_WHITELIST_SUCCESS,GET_APPWHITELIST_CSV_DATA_FAILED,GET_APPWHITELIST_CSV_DATA_SUCCESS, 
    DELETE_WHITELIST_CJSC_FAILED, DELETE_WHITELIST_CJSC_SUCCESS, REMOVE_USER_TOKEN_SUCCESS, REMOVE_USER_TOKEN_FAILED, GET_NOTIFICATIONS_SUCCESS, 
    GET_NOTIFICATIONS_FAILED, CLEARALL_NOTIFICATIONS_SUCCESS, CLEARALL_NOTIFICATIONS_FAILED,DUPLICATE_USER_FAILED,DUPLICATE_USER_SUCCESS,
    C_GET_ADVERTISER_SUCCESS,C_GET_ADVERTISER_FAILED,C_ADMIN_GET_S3FILESANDFOLDERS_FAILED,C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS, 
    GET_NOAS_COUNTER_SUCCESS,
    GET_NOAS_COUNTER_FAILED} from "../Actions/AdminActions";
import { TOAST_SHOW } from "../Actions/ToastAction";
import FileDownload from 'js-file-download';


export function* GetAdminAdvSaga(): unknown {
    try {
        // console.log("inside saga");
      const response = yield call(axios.get, "getAdvertisersList");
    //   console.log("after " + response.data);
      const { data, status } = response;
      if (status === 200) {
        yield put({ type: C_GET_ADVERTISER_SUCCESS, payload: data.advertisers });
      }
    } catch (error: any) {
      if (error.response.status === 500) {
        if (error.response.data.message) {
          yield put({
            type: TOAST_SHOW,
            payload: {
              message: error.response.data.message,
              severity: "Danger",
              show: true,
            },
          });
        }
      } else {
        yield put({
          type: TOAST_SHOW,
          payload: {
            message: "Something Went wrong please try again",
            severity: "Danger",
            show: true,
          },
        });
      }
  
      yield put({ type: C_GET_ADVERTISER_FAILED, payload: false });
    }
  }

  export function* GetAdminS3FoldersAndFilesSaga(action:any): unknown {
    try {
      const response = yield call(axios.get, `getS3List?root=${action.payload}`);
      const { data, status } = response;
      if (status === 200) {
        yield put({ type: C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS, payload: data });
      }
    } catch (error: any) {
      if (error.response.status === 500) {
        if (error.response.data.message) {
          yield put({
            type: TOAST_SHOW,
            payload: {
              message: error.response.data.message,
              severity: "Danger",
              show: true,
            },
          });
        }
      } else {
        yield put({
          type: TOAST_SHOW,
          payload: {
            message: "Something Went wrong please try again",
            severity: "Danger",
            show: true,
          },
        });
      }
  
      yield put({ type: C_ADMIN_GET_S3FILESANDFOLDERS_FAILED, payload: false });
    }
  } 


export function* GetLoggerDataSaga(action: any): unknown {
    // console.log('action', action.payload);

    try {
        const { start, end } = action.payload
        const response = yield call(axios.get, `csv-download?start=${start}&end=${end}`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_LOGGER_DATA_SUCCESS });
            FileDownload(data, `report_${start}_to_${end}.csv`);
        }

    } catch (e: any) {
        yield put({ type: GET_LOGGER_DATA_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* GetUsersListSaga(): unknown {
    try {
        const response = yield call(axios.get, 'get-user');
        // console.log(response);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_USERS_LIST_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_USERS_LIST_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* EditReportCradicialsSaga(action: any): unknown {
    try {
        const { _id, ...restData } = action.payload
        const id = _id ? `?id=${_id}` : ''
        const response = yield call(axios.post, `editCredential${id}`, restData);
        // console.log(response, response.data);

        const { status } = response

        if (status === 200) {
            yield put({ type: EDIT_CRADICIALS_SUCCESS, payload: true });
        }

    } catch (e: any) {
        yield put({ type: EDIT_CRADICIALS_FAILED, payload: false });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}


export function* GetReportCradicialsSaga(): unknown {
    try {
        const response = yield call(axios.get, 'getCredential');
        // console.log(response, response.data);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_CRADICIALS_SUCCESS, payload: data[0] });
        }

    } catch (e: any) {
        yield put({ type: GET_CRADICIALS_FAILED, payload: {} });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* ChangeUserRoleSaga(action: any): unknown {
    try {
        // console.log(action.payload);

        const { id, ...restData } = action.payload
        const response = yield call(axios.post, `change-roles?id=${id}`, restData);
        // console.log(response, response.data);

        const { status } = response

        if (status === 200) {
            yield put({ type: CHANGE_USER_ROLE_SUCCESS });
        }

    } catch (e: any) {
        yield put({ type: CHANGE_USER_ROLE_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* ChangeRoleAccessScrrenSaga(action: any): unknown {
    try {
        // console.log(action.payload);

        const { id, ...restData } = action.payload
        const response = yield call(axios.post, `change-access?roleId=${id}`, restData);
        // console.log(response, response.data);

        const { status } = response

        if (status === 200) {
            yield put({ type: CHANGE_ROLE_ACCESS_SCRREN_SUCCESS });
        }

    } catch (e: any) {
        yield put({ type: CHANGE_ROLE_ACCESS_SCRREN_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}
export function* AddNewUserSaga(action: any): unknown {
    try {

        const response = yield call(axios.post, `/addUser`, action.payload)
        const { data, status } = response

        if (status === 200) {
            yield put({ type: ADD_NEW_USER_SUCCESS, payload: true })
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Added Successfully!', severity: 'Success', show: true },
            });
            yield put({ type: GET_USERS_LIST_REQUEST, })
        } else if (status === 500) {
            yield put({
                type: TOAST_SHOW,
                payload: { message: data.message, severity: 'Danger', show: true },
            });
        }
    } catch (error: any) {

        if (error.response.status === 500) {
            if (error.response.data.message) {
                yield put({
                    type: TOAST_SHOW,
                    payload: { message: error.response.data.message, severity: 'Danger', show: true },
                });

            }
        } else {
            yield put({
                type: TOAST_SHOW,
                payload: { message: "Something Went wrong please try again", severity: 'Danger', show: true },
            });
            
        }
        
        yield put({ type: ADD_NEW_USER_FAILED, payload: false })
    }
}

export function* DeleteUserSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, "deleteUser", action.payload);
    const {
      //data,
      status,
    } = response;
    if (status === 200) {
      yield put({ type: DELETE_USER_SUCCESS });
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Deleted Successfully!",
          severity: "Success",
          show: true,
        },
      });
      yield put({ type: GET_USERS_LIST_REQUEST });
    }
  } catch (error) {
    yield put({ type: DELETE_USER_FAILED });
    yield put({
      type: TOAST_SHOW,
      payload: {
        message: "Something Went wrong please try again",
        severity: "Danger",
        show: true,
      },
    });
  }
}



export function* EditUserSaga(action: any): unknown {
    try {

        const response = yield call(axios.post, `/updateUser`, action.payload)
        const { data, status } = response

        if (status === 200) {
            yield put({ type: EDIT_USER_SUCCESS, payload: data })
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Updated Successfully!', severity: 'Success', show: true },
            });
        } else if (status === 500) {
            yield put({
                type: TOAST_SHOW,
                payload: { message: data.message, severity: 'Danger', show: true },
            });
        }
    } catch (error: any) {

        if (error.response.status === 500) {
            if (error.response.data.message) {
                yield put({
                    type: TOAST_SHOW,
                    payload: { message: error.response.data.message, severity: 'Danger', show: true },
                });

            }
        } else {
            yield put({
                type: TOAST_SHOW,
                payload: { message: "Something Went wrong please try again", severity: 'Danger', show: true },
            });
            
        }
        
        yield put({ type: EDIT_USER_FAILED, payload: false })
    }
}



export function* DuplicateUserSaga(action: any): unknown {
    try {

        const response = yield call(axios.post, `/duplicateUser`, action.payload)
        const { data, status } = response

        if (status === 200) {
            yield put({ type: DUPLICATE_USER_SUCCESS, payload: data })
            if(data && action?.successCallback && data.length > 0 ){
                let successcallbackFun = action?.successCallback;
                let lastObj = data[data.length - 1];
                setTimeout(()=>{
                    successcallbackFun(lastObj)
                },200); 
            }
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Duplicated Successfully!', severity: 'Success', show: true },
            });
        } else if (status === 500) {
            yield put({
                type: TOAST_SHOW,
                payload: { message: data.message, severity: 'Danger', show: true },
            });
        }
    } catch (error: any) {

        if (error.response.status === 500) {
            if (error.response.data.message) {
                yield put({
                    type: TOAST_SHOW,
                    payload: { message: error.response.data.message, severity: 'Danger', show: true },
                });

            }
        } else {
            yield put({
                type: TOAST_SHOW,
                payload: { message: "Something Went wrong please try again", severity: 'Danger', show: true },
            });
            
        }
        
        yield put({ type: DUPLICATE_USER_FAILED, payload: false })
    }
}

export function* getUserPermissionsSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `/getUsersDataCSV`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_USER_PERMISSION_DATA_SUCCESS });
            FileDownload(data, `user_permissions.csv`);
        }

    } catch (e: any) {
        yield put({ type: GET_USER_PERMISSION_DATA_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* uploadDomainWhitelistSaga(action: any): unknown {
    try {
         const response = yield call(axios.post, `/uploadDomains?id=${action.userid}`, action.payload);
        const { data, status } = response 

        if (status === 200) {
            yield put({ type: UPLOAD_DOMAIN_WHITELIST_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Domain whitelist uploaded successfully', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: UPLOAD_DOMAIN_WHITELIST_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* uploadAppWhitelistSaga(action: any): unknown {
    try {
         const response = yield call(axios.post, `/uploadBundles?id=${action.userid}`, action.payload);
        const { data, status } = response 

        if (status === 200) {
            yield put({ type: UPLOAD_APP_WHITELIST_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'App whitelist uploaded successfully', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: UPLOAD_APP_WHITELIST_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* getDomainWhitelistCSVSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `/getDomains?id=${action.payload}`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_DOMAINWHITELIST_CSV_DATA_SUCCESS });
            FileDownload(data, `domain_whitelist.csv`);
        }

    } catch (e: any) {
        yield put({ type: GET_DOMAINWHITELIST_CSV_DATA_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* getAppWhitelistCSVSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `/getBundles?id=${action.payload}`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_APPWHITELIST_CSV_DATA_SUCCESS });
            FileDownload(data, `app_whitelist.csv`);
        }

    } catch (e: any) {
        yield put({ type: GET_APPWHITELIST_CSV_DATA_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* deleteWhitelistSaga(action: any): unknown {
    try {
        const { userId, whitelistType } = action.payload;
        const response = yield call(axios.get, whitelistType ==='domain'?`/deleteDomainWhitelist?id=${userId}`:`/deleteAppWhitelist?id=${userId}`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: DELETE_WHITELIST_CJSC_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: whitelistType==='domain'?'Domain whitelist deleted!':'Bundle whitelist deleted!', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: DELETE_WHITELIST_CJSC_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}


export function* removeUserTokenSaga(action: any): unknown {
    try {
      const response = yield call(axios.post, "removeUserToken", action.payload);
      const { 
        status,
      } = response;
      if (status === 200) {
        yield put({ type: REMOVE_USER_TOKEN_SUCCESS });
        yield put({
          type: TOAST_SHOW,
          payload: {
            message: "Deleted Successfully!",
            severity: "Success",
            show: true,
          },
        });
      }
    } catch (error) {
      yield put({ type: REMOVE_USER_TOKEN_FAILED });
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }
  }

  export function* getNotificationsListSaga(): unknown {
    try {
        const response = yield call(axios.get, 'getNotifications'); 

        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_NOTIFICATIONS_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_NOTIFICATIONS_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}


export function* clearNotificationsListSaga(): unknown {
    try {
        const response = yield call(axios.get, 'clearNotifications'); 

        const { status } = response

        if (status === 200) {
            yield put({ type: CLEARALL_NOTIFICATIONS_SUCCESS, payload: [] });
        }

    } catch (e: any) {
        yield put({ type: CLEARALL_NOTIFICATIONS_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* GetNoasCounterSaga(action:any):unknown{
    try {
        const { startDate, endDate, dailyHourly } = action.payload
        const response = yield call(axios.get, `getNoasCounter?startDate=${startDate}&endDate=${endDate}&dailyHourly=${dailyHourly}`);
        yield put({ type: GET_NOAS_COUNTER_SUCCESS, payload: response.data });
      } catch (error) {
        yield put({ type: GET_NOAS_COUNTER_FAILED});
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
      }
}